export default __webpack_public_path__ + "static/media/gitlab.05f9a560.png";